// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__a61cg","col":"Table_col__1dHhF","fulfillmentStatus":"Table_fulfillmentStatus__3S0ze","emailCol":"Table_emailCol__3SVBC"};